var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBachelorHonors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5963",
    "data-name": "Group 5963",
    transform: "translate(10413 -5761)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-10413 5761)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mortarboard",
    transform: "translate(-10408 5767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M109.62,269.663v4.114a1.2,1.2,0,0,1-1.2,1.2h-10.3a1.2,1.2,0,0,1-1.2-1.2v-4.114l5.336,2.419a2.452,2.452,0,0,0,2.028,0Z",
    transform: "translate(-93.049 -260.341)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M20.438,41.623a1.244,1.244,0,0,0-.724-1.071l-8.963-4.183a1.254,1.254,0,0,0-1.064,0L.726,40.552a1.258,1.258,0,0,0,.013,2.285L9.7,46.9a1.257,1.257,0,0,0,1.038,0l8.506-3.856V53.2a.6.6,0,1,0,1.2,0C20.444,40.847,20.447,41.689,20.438,41.623Z",
    transform: "translate(0 -36.251)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBachelorHonors);
export default __webpack_public_path__ + "static/media/bachelor_honors.cd6a4542d91b328e07b0e394a9f758a7.svg";
export { ForwardRef as ReactComponent };